import unique from 'unique-selector';
import _ from 'lodash';

const countDomParents = (el: Element, count = 0) => {
  if (!el?.parentElement) return count;

  return countDomParents(el.parentElement, count + 1);
};

export type SavedScroll = {
  sel: string;
  top: number;
  scrollY: number;
};

export const saveScroll = () => {
  const { innerWidth, innerHeight } = window;

  // save elements towards the bottom of the page
  const els = [
    document.elementFromPoint(innerWidth * 0.25, innerHeight * 0.75),
    document.elementFromPoint(innerWidth * 0.5, innerHeight * 0.75),
    document.elementFromPoint(innerWidth * 0.75, innerHeight * 0.75),
    document.elementFromPoint(innerWidth * 0.25, innerHeight * 0.99),
    document.elementFromPoint(innerWidth * 0.5, innerHeight * 0.99),
    document.elementFromPoint(innerWidth * 0.75, innerHeight * 0.99),
  ];

  // get the deepest element, to make sure we are not calculating use <body> or other layout element
  const deepestEl = _.maxBy(els, (el) => countDomParents(el));

  const sel = unique(deepestEl);
  const top = deepestEl.getBoundingClientRect().top;
  const scrollY = window.scrollY;

  return { sel, top, scrollY } as SavedScroll;
};

export const restoreScroll = (savedScroll: SavedScroll) => {
  const { sel, top } = savedScroll;

  let retryCount = 0;
  const maxRetry = 10;

  const doRestore = () => {
    const el = document.querySelector(sel);
    retryCount++;

    if (retryCount > maxRetry) return;

    // retry
    if (!el) {
      console.log('SCROLL RESTORE retry', retryCount);
      setTimeout(doRestore, 500);
      return;
    }

    // scroll to saved DOM element
    const scrollToY = el.getBoundingClientRect().top - top;

    console.log('SCROLL RESTORE DOM el', scrollToY, window.scrollY);
    window.scrollTo(0, scrollToY);
  };

  // NOTE: setTimeout is only needed for very few edge cases.
  setTimeout(doRestore, 500);
};
